import React, { Component } from 'react';
import TableRowRadioButton from './TableRowRadioButton.jsx';
import { GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';
import { Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';

class TableRow extends Component {
    constructor(props) {
        super(props)
    }

    getDataEnterprise(id) {
        this.props.openModalInformacionEmpresa(id);
    }

    //FILAS
    render() {
        let classSelected = this.props.checked ? "selected" : "";

        let tableRow = (this.props.row.esNueva == false) ? <td className="left-separator-xxs">
            <TableRowRadioButton
                descripcion={this.props.row.Descripcion}
                ID={this.props.row.Id}
                isVigente={this.props.isVigente}
                checked={this.props.checked}
                disable={this.props.Disable}
                seleccionarEmpresa={this.props.seleccionarEmpresa}
                esNueva={this.props.row.esNueva}
            />
        </td> : <i><td className="left-separator-xxs">
            <TableRowRadioButton
                descripcion={this.props.row.Descripcion}
                ID={this.props.row.Id}
                isVigente={this.props.isVigente}
                checked={this.props.checked}
                disable={this.props.Disable}
                seleccionarEmpresa={this.props.seleccionarEmpresa}
                esNueva={this.props.row.esNueva}
            />
        </td></i>;

        let lastColumn = null;

        let iconoLapiz = <td className="td-algn td-algn-center">
            <Link to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_NUEVA_EMPRESA") + "/" + this.props.row.Id}>
                <span className="ti-pencil ti-md"></span>
            </Link>
        </td>;

        let iconoOjo = <td className="td-algn td-algn-center">
            <span className="ti-eye ti-link ti-md" onClick={(id) => this.getDataEnterprise(this.props.row.Id)}></span>
        </td>;

        const p1Condicion = (this.props.row.esNueva == true || (this.props.row.seleccionada == true && this.props.esModificacion == true));
        /*empresa en estado completada*/

        if (p1Condicion) {
            switch (this.props.row.EmpresaVisaEstadoId) {
                case 1: //Iniciada
                lastColumn = (this.props.row.Id == 0 || this.props.esModificacion == true ) ? iconoLapiz : iconoOjo;
                    break;
                case 3: //Operativa
                    switch (this.props.row.SolicitudEstado) {
                        case 11: //Empresa Rechazada por la Administradora
                        lastColumn = this.props.row.Id == 0 ? iconoLapiz : iconoOjo;
                            break;
                        default:
                            lastColumn = iconoOjo;
                    }
                    break;
                default:
            }
        }
        else {
            if (this.props.row.EmpresaVisaEstadoId == 3) { //3 = Operativa
                switch (this.props.row.SolicitudEstado) {
                    case 11: //Empresa Rechazada por la Administradora
                        if (this.props.row.seleccionada) {
                            lastColumn = this.props.row.Id == 0 ? iconoLapiz : iconoOjo;
                        } else {
                            lastColumn = iconoOjo;
                        }
                        break;
                    default:
                        if (this.props.row.seleccionada) {
                            lastColumn = this.props.row.Id == 0 ? iconoLapiz : iconoOjo;
                        } else {
                            lastColumn = iconoOjo;
                        }
                }
            }
            else {
                if (this.props.row.seleccionada) {
                    lastColumn = this.props.row.Id == 0 ? iconoLapiz : iconoOjo;
                } else {
                    lastColumn = iconoOjo;
                }
            }
        }

        const { novedad, row, CuentasTarjetas } = this.props;
        const { TipoDeEmpresa, LimiteCompra, limiteCompraFormato } = row;

        const limiteCompraDisplay = LimiteCompra != undefined ? LimiteCompra : limiteCompraFormato;

        const limiteCompraLoca = GlobalHelper.ConvertirNumeroSinDecimales(limiteCompraDisplay);
        
        return (
            <tr className={classSelected}>
                <td className="left-separator-xxs">
                    {tableRow}
                </td>
                <td>
                    <label className="label-secondary">{this.props.row.TipoDeEmpresa}</label>
                </td>
                <td className="td-algn td-algn-right">
                    <label className="label-secondary">$ {limiteCompraLoca}</label>
                </td>
                <td className="td-algn td-algn-center" colSpan="2">
                    <label className="label-secondary">{CuentasTarjetas}</label>
                </td>
                <td className="td-algn td-algn-center">
                    {lastColumn}
                </td>
            </tr>
        );
    }

};

export default TableRow